import React, { useEffect, useState } from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBus, faTrain } from '@fortawesome/free-solid-svg-icons';
import RouteDetailsRouteLeg from './RouteDetailsRouteLeg';
import NavigationButtons from './NavigationButtons';
import kayakImg from '../assets/kayak.png'; // Adjust relative path based on file location


<img
  src={kayakImg}
  alt="Book Hotels with Kayak"
  style={{ width: '100%', borderRadius: '10px', marginTop: '1rem' }}
/>

import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';





// Accepts a location object: {district, state, country}
function getKayakHotelUrl(locationObj, startDate, endDate) {
  const creatorId = "760";
  let destinationName = locationObj?.district || locationObj?.state || locationObj?.country || 'Kuala Lumpur';
  const majorPlaces = [
    'Sabah','Pahang','Penang','Sarawak','Kedah','Selangor','Negeri Sembilan','Kelantan',
    'Kuala Lumpur','Johor Bahru','Ipoh','Malacca','Kuantan','Kota Kinabalu','George Town','Johor'
  ];
  let urlmain;
  if (majorPlaces.includes(destinationName)) {
    if (destinationName === 'Sabah') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Sabah,Malaysia-p21083/${startDate}/${endDate}?sort=distance_a`;
    } else if (destinationName === 'Pahang') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Pahang,Malaysia-p21086/${startDate}/${endDate}?sort=distance_a`;
    } else if (destinationName === 'Penang') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Penang,Malaysia-p247880/${startDate}/${endDate}?sort=distance_a`;
    } else if (destinationName === 'Sarawak') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Sarawak,Malaysia-p21082/${startDate}/${endDate}?sort=distance_a`;
    } else if (destinationName === 'Kedah') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Kedah,Malaysia-p21092/${startDate}/${endDate}?sort=distance_a`;
    } else if (destinationName === 'Selangor') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Selangor,Malaysia-p21081/${startDate}/${endDate}?sort=distance_a`;
    } else if (destinationName === 'Negeri Sembilan') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Negeri-Sembilan,Malaysia-p21087/${startDate}/${endDate}?sort=distance_a`;
    } else if (destinationName === 'Kelantan') {
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/Kelantan-p21088/${startDate}/${endDate}?sort=distance_a`;
    } else {
      let encodedCityName = encodeURIComponent(locationObj.locality);
      urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/${encodedCityName}/${startDate}/${endDate}?sort=distance_a`;
    }
  } else {
    let encodedCityName = encodeURIComponent(locationObj.locality);
    urlmain = `https://kayak.com.my/in?a=kan_262812_573418&enc_cid=${creatorId}&lc=en&url=%2Fhotels/${encodedCityName}/${startDate}/${endDate}?sort=distance_a`;
  }
  return urlmain;
}

function sanitizeKayakLocation(location) {
  if (!location) return '';
  return location
    .replace(/\s*,\s*/g, ',')
    .replace(/,+/g, ',')
    .replace(/^,|,$/g, '')
    .trim();
}

const RouteDetailsTransit = ({ 
  from, 
  to, 
  selectedRoute, 
  setShowPublicRouteOverlay, 
  setSelectedRoute,
  getTransitIcon 
}) => {
  console.log('RouteDetailsTransit Props:', {
    from,
    to,
    selectedRoute,
    hasSetShowPublicRouteOverlay: !!setShowPublicRouteOverlay,
    hasSetSelectedRoute: !!setSelectedRoute,
    hasGetTransitIcon: !!getTransitIcon
  });


//REACT_APP_GOOGLE_MAPS_API_KEY=AIzaSyCVdBi_3QNNrM5XEWFWYtwqZefix0xx5Ew


  const GOOGLE_API_KEY = 'AIzaSyB40jqFnXxo_4ZX7WezdrlR4NicJsseyu8';

async function geocodePlaceName(placeName) {
  if (!placeName) return null;

  const endpoint = `https://maps.googleapis.com/maps/api/geocode/json?address=${encodeURIComponent(placeName)}&key=${GOOGLE_API_KEY}`;

  try {
    const response = await fetch(endpoint);
    const data = await response.json();

    if (data.status === 'OK') {
      const result = data.results[0];
      const components = result.address_components;
      const get = (type) => components.find(c => c.types.includes(type))?.long_name;

      return {
        locality: get('locality'),
        district: get('administrative_area_level_2'),
        state: get('administrative_area_level_1'),
        country: get('country'),
        fullAddress: result.formatted_address,
        lat: result.geometry.location.lat,
        lng: result.geometry.location.lng,
      };
    } else {
      console.error('Geocoding failed:', data.status);
      return null;
    }
  } catch (err) {
    console.error('Geocoding error:', err);
    return null;
  }
}

  const [toLocationObj, setToLocationObj] = useState(null);

  useEffect(() => {
    if (typeof to === 'string') {
      geocodePlaceName(to).then((res) => {
        console.log(res, "aaaaaaaa");
        setToLocationObj(res);
      });
    }
  }, [to]);
  

  if (!selectedRoute) {
    console.log('No selectedRoute provided to RouteDetailsTransit');
    return null;
  }
  const today = new Date();
  const startDate = new Date(today);
  startDate.setDate(today.getDate() + 1);
  
  const endDate = new Date(today);
  endDate.setDate(today.getDate() + 3);
  
  const formattedStart = startDate.toISOString().split('T')[0];
  const formattedEnd = endDate.toISOString().split('T')[0];
  
  return (
    <div style={styles.overlay}>
      {/* Header */}
      <div style={styles.header}>
        <div style={styles.title}>
          <FontAwesomeIcon icon={faBus} style={{ color: '#2A3075' }} />
          <FontAwesomeIcon icon={faTrain} style={{ color: '#2A3075' }} />
          {from} to {to}
        </div>
        <button onClick={() => setShowPublicRouteOverlay(false)} style={styles.closeButton}> <FontAwesomeIcon icon={faArrowLeft} /></button>
      </div>

      {/* Route Summary */}
      <div style={styles.summary}>
        <div>⏱ <strong>{selectedRoute.duration}</strong> • {selectedRoute.distance}</div>
        <div>🧾 <strong>{selectedRoute.fare}</strong> • {selectedRoute.noOfPassenger} passenger</div>
      </div>

      {/* Route Steps */}
      <div style={styles.routeSteps}>
        {selectedRoute.routeDetails && selectedRoute.routeDetails.map((step, index) => (
          // <div key={index}>{JSON.stringify(step)}</div>
          <RouteDetailsRouteLeg
            index={index}
            step={step}
            getTransitIcon={getTransitIcon}
            setShowPublicRouteOverlay={setShowPublicRouteOverlay}
            selectedRoute={selectedRoute}
            todayDate={today.toISOString().split('T')[0]}
          />
        ))}
      </div>

      <NavigationButtons
        from={from}
        to={to}
        setSelectedRoute={setSelectedRoute}
        selectedRoute={selectedRoute}
        travelMode="transit"
      />
        {(toLocationObj && (toLocationObj.locality || toLocationObj.district)) && (
          <div style={styles.adContainer}>
            <a
              href={getKayakHotelUrl(
                toLocationObj.locality ? toLocationObj : { district: toLocationObj.district },
                formattedStart,
                formattedEnd
              )}
              target="_blank"
              rel="noopener noreferrer"
              style={styles.adFullLink}
            >
              <div style={styles.hotelAdText}>
                🏨 <strong style={{ margin: '0 8px' }}>Book Hotels Nearby</strong> 📍
              </div>
            </a>
          </div>
        )}


    </div>

  );
};

const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1001,
    backgroundColor: '#fff',
    padding: '1rem',
    overflowY: 'auto',
    paddingBottom: '100px'
  },
 
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '1.2rem'
  },
  title: {
    fontSize: '1.2rem',
    fontWeight: 'bold',
    color: '#1E1E1E',
    display: 'flex',
    alignItems: 'center',
    gap: '10px'
  },
  closeButton: {
    fontSize: '1.5rem',
    background: 'none',
    border: 'none',
    color: '#333',
    cursor: 'pointer'
  },
  summary: {
    fontSize: '1rem',
    color: '#444',
    marginBottom: '1.5rem',
    lineHeight: 1.6
  },
  routeSteps: {
    display: 'flex',
    flexDirection: 'column',
    gap: '1rem'
  },
  adContainer: {
    width: '100%',
    height: '100px',
    backgroundColor: '#001f3f',
    borderRadius: '10px',
    marginTop: '1.5rem',
    overflow: 'hidden',
    justifyContent:'center',
    alignItems:'center'
  },
  adLink: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
    textDecoration: 'none'
  },
  adContent: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px'
  },
  adText: {
    color: '#ffffff',
    fontWeight: 'bold',
    fontSize: '16px'
  },
  adIcon: {
    fontSize: '18px'
  },
  hotelAdWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: '12px',
    width: '100%',
  },
  
  hotelAdLink: {
    backgroundColor: '#0B1E3D',
    borderRadius: '12px',
    padding: '10px 20px',
    textDecoration: 'none',
    display: 'inline-block',
    width: 'fit-content'
  },
  
  hotelAdText: {
    color: 'white',
    fontSize: '16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  adContainer: {
    width: '100%',
    height: '100px',
    backgroundColor: '#001f3f',
    borderRadius: '10px',
    marginTop: '1.5rem',
    overflow: 'hidden',
   
    justifyContent: 'center',
    alignItems: 'center'
  },
  adContainer: {
   
    width: '100%',
    height: '100px',
    backgroundColor: '#ffd100',
    borderRadius: '10px',
    marginTop: '0.5rem',
    overflow: 'hidden',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.15)'

  },
  
  adFullLink: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    textDecoration: 'none',
  },
  
  hotelAdText: {
    color: '#ffffff',
    fontSize: '16px',
    fontWeight: 'bold',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '8px',
  }
  
  
  
  
};

export default RouteDetailsTransit; 